import { StockClassAdditionalInformation } from '@commenda/types/src/cap-table/types';
import { fetcher } from '@commenda/utils';
import { StockClassType } from '@prisma/client';

interface CreateStockClassParams {
  type: StockClassType;
  name: string;
  additionalInformation: StockClassAdditionalInformation;
  corporationId: number;
  workRequestId?: string;
}

export async function createStockClass(params: CreateStockClassParams) {
  try {
    const res = await fetcher(`capTable/stockClass`, {
      method: 'POST',
      body: params,
    });

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
